<template>
  <div
    v-wave
    class="flex items-center gap-3 px-4 py-3 border-b border-gray-100 cursor-pointer hover:bg-gray-50 md:rounded-md md:border md:my-2"
    @click="$emit('click')"
  >
    <div class="w-11 h-11 rounded-full flex items-center justify-center bg-gradient-to-br from-[#ddd8fc] to-[#a691f4] flex-shrink-0">
      <i class="pi pi-id-card text-base text-primary" />
    </div>

    <div class="flex-1 min-w-0">
      <div class="flex items-baseline justify-between gap-2">
        <div class="text-[15px] font-semibold text-gray-900 truncate">
          {{ pack.templateName || 'כרטיסייה' }}
        </div>
        <span
          class="text-[11px] font-medium px-2 py-0.5 rounded-full whitespace-nowrap"
          :class="statusChip.classes"
        >{{ statusChip.label }}</span>
      </div>

      <div class="flex items-center gap-1.5 mt-1 text-[13px] text-gray-600">
        <span>{{ customerName || 'ללא לקוח' }}</span>
      </div>

      <div class="flex items-center gap-1.5 mt-2">
        <div class="flex gap-1">
          <span
            v-for="i in pack.totalUses"
            :key="i"
            class="w-1.5 h-1.5 rounded-full"
            :class="i <= usedCount ? 'bg-primary' : 'bg-gray-200'"
          />
        </div>
        <span class="text-[12px] text-gray-500 mr-auto">
          {{ usedCount }}/{{ pack.totalUses }} מומשו
          <template v-if="pack.expiresAt"> · עד {{ formattedExpiry }}</template>
        </span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, PropType } from 'vue';
import { BundlePackStatus, ICustomerBundlePackWithCustomer } from '@torim-app/types';
import { DateTime } from 'luxon';

const props = defineProps({
  pack: {
    type: Object as PropType<ICustomerBundlePackWithCustomer>,
    required: true
  }
});

defineEmits<{ (e: 'click'): void }>();

const customerName = computed(() => props.pack.customerName);

const usedCount = computed(() => Math.max(0, (props.pack.totalUses ?? 0) - (props.pack.remainingUses ?? 0)));

const formattedExpiry = computed(() => {
  if (!props.pack.expiresAt) return '';
  return DateTime.fromISO(String(props.pack.expiresAt)).toFormat('dd.MM.yyyy');
});

const statusChip = computed(() => {
  switch (props.pack.status) {
    case BundlePackStatus.Active:
      return { label: 'פעיל', classes: 'bg-green-100 text-green-700' };
    case BundlePackStatus.Exhausted:
      return { label: 'נוצל', classes: 'bg-gray-100 text-gray-600' };
    case BundlePackStatus.Expired:
      return { label: 'פג תוקף', classes: 'bg-red-100 text-red-700' };
    case BundlePackStatus.PendingPayment:
      return { label: 'ממתין לתשלום', classes: 'bg-amber-100 text-amber-700' };
    case BundlePackStatus.Cancelled:
      return { label: 'בוטל', classes: 'bg-gray-100 text-gray-500' };
    default:
      return { label: '', classes: '' };
  }
});
</script>
